import { Header } from "./Header";

export class Preferences {
  planogrammeFilters: string = "";
  
  sectionsFilters: string = "";
  
  planogrammeColumns?: Header[];
  
  sectionsColumns?: Header[];
}